import * as Sentry from '@sentry/react';
import { dropUntrustedEventRejections } from './sentryFilters';

export const isSentryEnabled =
  process.env.NODE_ENV !== 'development' && Boolean(process.env.SENTRY_DSN);

if (isSentryEnabled) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    beforeSend: dropUntrustedEventRejections,
  });
}
